import React, { useEffect, useState } from 'react';
import { APP_CONST } from '../../../constants';
import { 
    GeckoCard, 
    GeckoAlert, 
    GeckoBtn,
    Spinner
} from '../../../components';
import { $state, $stateParams } from '../../../router';
import { Auth, ClientManager } from '../../../services';
import ErrorTracker from '../../../services/ErrorTracker';
import ProfileSelector from '../../../components/ProfileSelector';
import Redirect from '../../../services/Redirect';

const Integration = (props) => {
    const [error, setError] = useState(null);
    const [issueInFlight, setIssueInFlight] = useState(false);

    const enableAutoRedirect = ($stateParams.ar && $stateParams.ar === 'false' ? false : true);

    const callback = (response) => {
        callbackToOpener(response);
    }

    const selectGeckoFormAccount = (geckoFormAccountId) => {
        setIssueInFlight(true);

        return issueIntegrationTokens($stateParams.accountId, geckoFormAccountId).then((response) => {
            callback(response);
        }).catch((err) => {
            if (err instanceof Error) {
                ErrorTracker.captureException(err);
                setError(err.message);
            } else if (err.Error) {
                ErrorTracker.captureException(err.Error);
                setError(err.Error);
            } else {
                ErrorTracker.captureException(err);
                setError(err);
            }

            setIssueInFlight(false);
        });
    };  

    const onSelectProfile = (profile) => {
        selectGeckoFormAccount(profile.AccountId);
    }

    useEffect(() => {
        if (!$stateParams.accountId) {
            setError('No GeckoChat account found');
        }
    }, []);

    if (error) {
        return (
            <div>
                <GeckoAlert type={APP_CONST.ALERT_TYPE_DANGER} size="lg">
                    {error}
                </GeckoAlert>

                <LogoutButton />
            </div>
        );
    }

    if (issueInFlight) {
        return (
            <div>
                <Loading />
            </div>
        );
    }

    return(
        <div id="module-select-profile">
            <GeckoCard>
                <ProfileSelector 
                    client="integration" 
                    app="geckoform" 
                    onSelectProfile={onSelectProfile} 
                    autoRedirect={enableAutoRedirect}
                    onError={(err) => setError(err.message)}
                />
            </GeckoCard>

            <LogoutButton />
        </div>
    );
};

const issueIntegrationTokens = (geckoChatAccountId, geckoFormAccountId) => {
    return Auth.integration.issue(geckoChatAccountId, geckoFormAccountId);
}

const LogoutButton = () => {
    return (
        <div>
            <GeckoBtn
                name="Logout"
                icon={'LogOut'}
                type={APP_CONST.BTN_TYPE_DANGER}
                handler={() => {
                    Redirect.set(window.location.href);

                    $state.go('logout', {
                        client: ClientManager.client(),
                        app: ClientManager.app(),
                    });
                }}
            />
        </div>
    );
}

const Loading = () => {
    return (
        <div>
            <Spinner size="small"/>
        </div>
    );
}

const callbackToOpener = (payload) => {
    if (window.opener) {
        window.opener.postMessage(JSON.stringify(payload), '*');
    } else {
        console.error('No opener available');
    }
}

export default Integration;
